import React, { Component } from 'react';
import orderService from '../../services/order.service';

import './OrderSchedule.css';

declare var $;
declare var jQuery;
class OrderSchedule extends Component {

  constructor(props) {
    super(props);
    this.state = {
      orderId: '',
      recieved: false,
      schedules: []
    }
    this.getOrderSchedules = this.getOrderSchedules.bind(this)
    this.orderSchedules = this.orderSchedules.bind(this)
  }

  componentDidUpdate() {
      this.addTabsInteraction()
  }

  componentWillReceiveProps(nextProps) {
   if(nextProps.storeId && !this.state.recieved) {
    let orderId = nextProps.storeId
    this.setState({
      orderId,
      recieved: true
    })
    this.getOrderSchedules(orderId)
   }
  }

  addTabsInteraction() {
    var Tabs = function($) {
  return {

    init: function() {
      this.cacheDom();
      this.setupAria();
      this.bindEvents();
    },

    cacheDom: function() {
      this.$el = $('.tabs');
      this.$tabList = this.$el.find('ul');
      this.$tab = this.$tabList.find('li');
      this.$tabFirst = this.$tabList.find('li:first-child a');
      this.$tabLink = this.$tab.find('a');
      this.$tabPanel = this.$el.find('section');
      this.$tabPanelFirstContent = this.$el.find('section > *:first-child');
      this.$tabPanelFirst = this.$el.find('section:first-child');
      this.$tabPanelNotFirst = this.$el.find('section:not(:first-of-type)');
    },

    bindEvents: function() {
      this.$tabLink.on('click', function(){
        this.changeTab();
      }.bind(this));
      this.$tabLink.on('keydown', function() {
        this.changeTabKey();
      }.bind(this));
    },

    changeTab: function() {
      var self = $(event.target);
      event.preventDefault();
      this.removeTabFocus();
      this.setSelectedTab(self);
      this.hideAllTabPanels();
      this.setSelectedTabPanel(self);
    },


    changeTabKey: function() {
      var self = $(event.target),
        $target = this.setKeyboardDirection(self, event.keyCode);

      if ($target.length) {
        this.removeTabFocus(self);
        this.setSelectedTab($target);
      }
      this.hideAllTabPanels();
      this.setSelectedTabPanel($(document.activeElement));

    },

    hideAllTabPanels: function() {
      this.$tabPanel.attr('aria-hidden', 'true');
    },

    removeTabFocus: function(self) {
      var $this = self || $('[role="tab"]');

      $this.attr({
        'tabindex': '-1',
        'aria-selected': null
      });
    },

    selectFirstTab: function() {
      this.$tabFirst.attr({
        'aria-selected': 'true',
        'tabindex': '0'
      });
    },

    setupAria: function() {
      this.$tabList.attr('role', 'tablist');
      this.$tab.attr('role', 'presentation');
      this.$tabLink.attr({
        'role': 'tab',
        'tabindex': '-1'
      });
      this.$tabLink.each(function() {
        var $this = $(this);

        $this.attr('aria-controls', $this.attr('href').substring(1));
      });
      this.$tabPanel.attr({
        'role': 'tabpanel'
      });
      this.$tabPanelFirstContent.attr({
        'tabindex': '0'
      });
      this.$tabPanelNotFirst.attr({
        'aria-hidden': 'true'
      });
      this.selectFirstTab();
    },

    setKeyboardDirection: function(self, keycode) {
      var $prev = self.parents('li').prev().children('[role="tab"]'),
          $next = self.parents('li').next().children('[role="tab"]');

      switch (keycode) {
        case 37:
          return $prev;
          break;
        case 39:
          return $next;
          break;
        default:
          return false;
          break;
      }
    },

    setSelectedTab: function(self) {
      self.attr({
        'aria-selected': true,
        'tabindex': '0'
      }).focus();
    },

    setSelectedTabPanel: function(self) {
      $('#' + self.attr('href').substring(1)).attr('aria-hidden', null);
    },

  };
}(jQuery);

Tabs.init();
  }

  async getOrderSchedules(orderId) {
   let response = await orderService.getOrderSchedule(orderId);
   this.orderSchedules(response)
  }

  orderSchedules(not_schedules) {
    let schedules = [];
    for(let day in not_schedules) {
        let date = [];
        date.day = day;
        date.hours = not_schedules[day]
        schedules.push(date)
    }
    this.setState({
      schedules
    })
    console.log(this.state.schedules)
  }

  render() {
    let days = [];
    let hours = [];

    for( let schedule of this.state.schedules) {
      let one_hour = [];
      days.push(
         <li key={schedule.day} ><a href={"#" + schedule.day}>{schedule.day}</a></li>
      )
      for(let hour of schedule.hours) {
         one_hour.push(
           <p >{hour.start_time} -{hour.end_time} </p>
         )
      }
      hours.push(
        <section key={schedule.day + '1'} id={schedule.day}>
           {one_hour}
        </section>
      )
    }

    return (
      <div className="row">
      <div className="col-md-6 col-md-push-3">
      <div className="tabs">
        <ul>
         {days}
        </ul>
         {hours}
        </div>
      </div>
      </div>

    );
  }
}


export default OrderSchedule;



// WEBPACK FOOTER //
// ./src/components/order-schedule/OrderSchedule.js